<template>
    <div>
        <dv-full-screen-container class="bg">

            <div class="d-flex flex-row mb-3 justify-content-start align-items-center w-100"
                 style="height: 8%" @click="switchScreenFull">
                <dv-decoration-6 style="width:20%;height:60%;"/>
                <dv-decoration-11 class="dv-card-title h-100" style="width:60%;font-size: 2rem">
                    <dv-decoration-9 style="width:45px;height:45px;"></dv-decoration-9>&nbsp;
                    OEE全面设备效率看板 Monthly Equipment Status&nbsp;&nbsp;
                    <p class="dv-card-title" style="font-size: 1.6rem;color: #08e5ff">
                        {{ datetime.substring(0, 11) }}</p>
                    <p class="dv-card-title p-2" style="font-size: 1.6rem;color: #08e5ff">{{
                            datetime.substring(11, 19)
                        }}</p>
                </dv-decoration-11>
                <dv-decoration-6 :reverse="true" style="width:20%;height:60%;"/>

            </div>

            <div class="row" style="height: 90%;margin: 5px 30px;">
                <div class="col-12 h-29">

                    <div class="row d-flex justify-content-around" style="height: 100%">
                        <div class="col-6 h-95">
                            <p class="decorative-text">部件（Parts）</p>
                            <!--                            <dv-decoration-7 class="dv-card-title" style="width:200px;height:40px;">&nbsp;&nbsp;Parts&nbsp;&nbsp;</dv-decoration-7>-->

                            <OeeDeptCount style="height: 100%" :queryDate="queryDate"></OeeDeptCount>
                        </div>
                        <div class="col-4 h-95 text-right">
                        </div>
                        <div class="col-1 h-95 text-right decorative-button">

                            <el-date-picker v-model="queryDate" type="date"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="统计月份"
                                            style="width: 100%;"></el-date-picker>
                        </div>
                        <div class="col-1 h-95 text-right decorative-button">

                            <!-- 返回按钮 -->
                            <!--                            <el-button type="primary" icon="el-icon-back" @click="goBack">返回设备管理页</el-button>-->
                            <router-link to="/em?menuId=15752&pathType=" class="return-button">
                                <i class="el-icon-arrow-left"></i> 返 回
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="col-12 h-29">

                    <div class="row d-flex justify-content-around" style="height: 100%;">
                        <div class="col-12 h-95" style="text-align: left;">
                            <p class="decorative-text">转子 & 定子（Rotor & Stator）</p>
                            <!--                            <dv-decoration-7 class="dv-card-title" style="width:200px;height:40px;">Rotor & Stator-->
                            <!--                                &nbsp;&nbsp;-->
                            <!--                            </dv-decoration-7>-->
                            <OeeRotorStatorGroupCount style="height: 100%"
                                                      :queryDate="queryDate"></OeeRotorStatorGroupCount>
                        </div>
                    </div>
                </div>

                <div class="col-12 h-29">

                    <div class="row d-flex justify-content-around" style="height: 100%">
                        <div class="col-12 h-95">
                            <p class="decorative-text">缸体（Casing）</p>
                            <!--                            <dv-decoration-7 class="dv-card-title" style="width:200px;height:40px;">Casing &nbsp;&nbsp;-->
                            <!--                            </dv-decoration-7>-->
                            <OeeCasingGroupCount style="height: 100%" :queryDate="queryDate"></OeeCasingGroupCount>
                        </div>
                    </div>
                </div>

            </div>

        </dv-full-screen-container>
    </div>
</template>

<script>

import screenfull from 'screenfull'
import EmCommonApi from "@/mixin/em/common/api";
import moment from "moment";
import OeeDeptCount from "./charts/OeeDeptCount.vue"
import OeeRotorStatorGroupCount from "./charts/OeeRotorStatorGroupCount.vue"
import OeeCasingGroupCount from "@/components/echarts-part/tpm/oee/charts/OeeCasingGroupCount.vue";

export default {
    name: "OeeMesLayout",
    mixins: [EmCommonApi],
    components: {
        OeeDeptCount,
        OeeRotorStatorGroupCount,
        OeeCasingGroupCount,
    },
    data() {
        return {
            datetime: '',
            rateConfig: {},
            planHour: 0,
            workHour: 0,
            finishPlanHour: 0,
            currentWorkshop: 0,
            wsEnable: [true, true, true, true],
            indicatorPosition: '',
            arrow: 'hover',
            workshopCodeIndex: 0,
            refresh: {
                everySecond: {},
                everyHour: {},
                atTwoClock: {}
            },
            vIfLazyLoad: false,
            pageLoad: true,
            equipmentStatus1: "esParts",
            equipmentStatus2: "esRotors",
            equipmentStatus3: "esCasing",
            queryDate: "",
        }
    },
    created() {
        if (!screenfull.isFullscreen) {
            screenfull.toggle()
        }
    },
    mounted() {
        this.fnResize()
        window.addEventListener('resize', this.fnResize, false)
        //this.getSafetyDate()

        this.intervals()
        setTimeout(() => this.vIfLazyLoad = true, 2000);
        //this.subscribeChannels();//订阅
    },
    beforeDestroy() {
        this.clearIntervals()
        window.removeEventListener('resize', this.fnResize, false)
        document.documentElement.style.fontSize = '16px';

        // 退出页面前，退出全屏
        if (screenfull.isFullscreen) {
            screenfull.exit();
        } else if (document.fullscreenElement) {
            document.exitFullscreen();
        }
    },

    methods: {
        intervals() {
            this.refresh.everySecond = setInterval(() => {
                this.datetime = moment(new Date()).format(this.$t("em.datetime.format.viewMode"))
            }, 1000);

            // this.refresh.everyHour = setInterval(() => {
            //     //this.getSafetyDate()
            //
            //     console.clear();//clear logs every hour
            // }, 3600 * 1000);
            //
            // this.refresh.atTwoClock = setInterval(() => {
            //     const now = new Date();
            //     if (now.getHours() === 2 && now.getMinutes() === 0) {
            //         this.reloadPage();
            //     }
            // }, 20000);
        },
        clearIntervals() {
            clearInterval(this.refresh.everySecond);
            clearInterval(this.refresh.everyHour);
            clearInterval(this.refresh.atTwoClock);
        },

        switchScreenFull() {
            screenfull.toggle();
            this.fnResize()
        },

        fnResize() {
            let deviceWidth = document.documentElement.clientWidth || window.innerWidth;
            document.documentElement.style.fontSize = (deviceWidth / 125) + 'px';
        },
        carousel(index) {
            this.currentWorkshop = index
        },
        reloadPage() {
            this.$emit('needReload');
        },
        goBack() {
            // 退出全屏(尝试各种浏览器退出全屏)
            // 【注意】如果你使用F11键全屏，通过JavaScript 是无法退出的，因为浏览器限制了对于全屏模式的控制。用户通常需要手动按下F11键来退出全屏。
            // JavaScript的全屏API通常用于进入和退出由Web应用程序管理的全屏模式，而不是浏览器的F11全屏模式。
            // 所以，如果你的页面是使用F11键进入全屏的，你不能使用JavaScript来控制退出，这是浏览器的安全限制。
            if (screenfull.isFullscreen) {
                screenfull.exit();
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            }

            // 返回到上一页或者使用你的返回逻辑
            this.$router.push('/em?menuId=15752&pathType=');
        }
    }
}
</script>

<style scoped>
.bg {
    background-color: #1B1534;
    padding: 0.2rem 0.2rem 0 0.2rem;
    background-image: url("../../../../assets/images/emKpi/oeeBack2.jpg");
    background-size: cover;
    background-position: center center;
}

.dv-card-title {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 1.5rem;
    color: #7ec699;
    font-weight: 700;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.date-card {
    background-color: rgba(4, 49, 128, .6);
    height: 5.5rem;
    width: 5.5rem;
    margin: auto;
    padding: 0
}

.date-card-number {
    color: #08e5ff;
    font-size: 2.8rem;
    font-weight: bold;
    text-align: center;
    margin: 0.5rem
}

.numbers {
    position: relative;
    overflow: hidden;
    border-radius: 0.375rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00ffc4;
    font-weight: 700;
    font-size: 1.5rem;
    margin: auto;
}

.fill {
    width: 100%;
    height: 100%;
}

.w-100 >>> text {
    font-size: 1.6rem;
}

.float-above {
    position: absolute;
    z-index: 9999;
}

.p1 {
    left: 2rem;
    top: 1rem;
    color: #7ec699;
    font-size: 2rem !important;
}

.p2 {
    right: 1rem;
    bottom: 0;
    color: #1294fb;
    font-size: 1rem
}

.svg-cover {

}

.dv-card-title.title-a {
    font-size: 1.2rem;
    color: white;
}

.number-sub {
    color: #6df9c6;
    font-size: 1rem;
    font-weight: bold;
}

.decorative-text {
    font-size: 1.5rem;
    background-color: #009966; /* 设置背景颜色为绿色 */
    color: white; /* 设置文字颜色为白色 */
    font-weight: bold; /* 设置文字为粗体 */
    border-radius: 3px; /* 设置圆角边框 */
    padding: 3px 15px; /* 设置内边距，根据需要调整 */
    display: inline-block; /* 使元素变成行内块级元素，以适应文本内容 */
    width: 24rem;
    text-align: left;
}

.return-button {
    font-size: 1rem;
    background-color: #409eff; /* 设置按钮背景颜色 */
    color: #fff; /* 设置文字颜色 */
    padding: 10px 20px; /* 设置内边距 */
    text-decoration: none; /* 去掉下划线 */
    border-radius: 5px; /* 圆角 */
}

.return-button:hover {
    background-color: #66b1ff; /* 鼠标悬停时的颜色 */
    color: #ffffff; /* 设置文字颜色 */
}

.decorative-button {
    font-size: 1.8rem;
    font-weight: bold; /* 设置文字为粗体 */
    border-radius: 10px; /* 设置圆角边框 */
    padding: 5px 0px; /* 设置内边距，根据需要调整 */
    display: inline-block; /* 使元素变成行内块级元素，以适应文本内容 */
    width: 100%;
    text-align: center;
    padding: 0.5rem 1rem;
}

/* 设置根元素的字体大小为基准大小 */
html {
    font-size: 16px;
}

/deep/ .el-input__inner {
    height: 2.5rem;
    font-size: 0.8rem;
}


</style>
